import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import SingleChart from "../../shared/charts/SingleChart";
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import * as  FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { LOADING } from "../../action";
import { postRequest } from "../../services/ApiServices";
import moment from 'moment';
import Button from '@mui/material/Button';
import { useDispatch } from "react-redux";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CancelIcon from '@mui/icons-material/Cancel';
import FormControl from "@material-ui/core/FormControl";
import Select from '@material-ui/core/Select';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const useStyles = makeStyles((theme) => ({
    heading: {
        color: "#ff4717",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,

    },  
    theadingstyles: {
        background: "rgb(26 26 49)",
        padding: "12px",
        borderTopRightRadius: "10px",
        borderTopLeftRadius: "10px",
        color: "white",
        fontSize: "16px",
    },
}));

export default function AllChart (props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {chartParameters,transformerListequip,formObj,transformerId} = props;
    // const title = chartParameters.title;
    // const testParameter = chartParameters.field
    const [chartData, setChartData] = React.useState([]);
    const [chartResData, setChartResData] = React.useState([]);
    const [chartTestParameter, setChartTestParameter] =React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [showchart, setShowChart] = React.useState([]);
const [selectBox, setSelectBox] = React.useState({
    'a': 'select',
    'b': 'select',
    'c': 'select',
    'd': 'select',
    'e': 'select',
  });
  React.useEffect(() => {
    clearChart()
},[transformerListequip])

const handleClickFileDownload = (chartType) => {
    exportToExcel(chartResData)
    
};

const exportToExcel = async (excelDate, fileName) => {
  excelDate.forEach((d) => {
      let result = d.name.split("-");
      d.Name = result[0] + " ( " + d.imoNumber + " ) ";;
      d.EquipmentName = result[1];
      d.TestParameter = d.testParameter;

      if (d.dataEntryDt) {
        d.ReportDate = moment(d.dataEntryDt).format('DD-MM-YYYY');
      }

      d.TestCount = d.testCountcss;
      d.SampleControlNo = d.sampleControlNoCd
      delete d.name
      delete d.imoNumber
      delete d.testParameter
      delete d.testCountcss
      delete d.sampleControlNoCd
      delete d.pdfFileName
      delete d.dataEntryDt
  })
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(excelDate);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
}

const handleClickOpen = (chartType) => {       
    setShowChart(chartData);
    setOpen(true);
};

const handleClose = () => {
    setOpen(false);
};
const setSelectedTestParameterChat6 = (event) => {
    let checkedList =  chartTestParameter;
    var isChecked = event.target.checked;
    if (isChecked) {
      checkedList.push(event.target.name);
    } else {
      let testparametersIndex = checkedList.indexOf(event.target.name);
      checkedList.splice(testparametersIndex, 1);
    }
    // //console.log(checkedList);
    setChartTestParameter(checkedList);
    // //console.log(chart4TestParameter);
    if (checkedList.length) {
        getChartData(checkedList);
    } else {
        setChartData([]);
    }
  };
  const  getChartData = (chatType) => {
    debugger
    //;
    dispatch({ type: LOADING, payload: true });
    let filterValidObj = {};
    var tarKeys = []; transformerListequip.forEach((obj) => { tarKeys.push(obj.shipId) });
    filterValidObj = { ...filterValidObj, vesselKey: tarKeys.join() }
    filterValidObj = { ...filterValidObj, testParameter: chatType.join()}
    filterValidObj = { ...filterValidObj, equipmentKey: transformerId.join() }
    const url =
    process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Trend/Vessels/Filter`;
   
    postRequest(url, filterValidObj)
    .then((res) => {
        debugger
        let data=[];
        res.data.forEach((d) => {
            d.dataEntryDt = moment(d.dataEntryDt).format('YYYY/MM/DD');
            if (d.dataEntryDt > formObj.bunkeredFromDate && d.dataEntryDt < formObj.bunkeredToDate){
                data.push(d)
            }
        })
        res.data=data;
        let result = getData(res.data);
            if (result.length) {
                setChartData(result);
                setChartResData(res.data);
            } else {
                setChartData([]);
            }
        dispatch({ type: LOADING, payload: false });
    })
    .catch((error) => {
        dispatch({ type: LOADING, payload: false });
    });

  };

  function getData(x) {
    //console.log("Chart Data:",x);
    var mon = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var transformersName = [];
    x.forEach((rec) => {
      transformersName.push(rec.name);
    });
    transformersName = [...new Set(transformersName)];
    var testParms = [];
    x.forEach((rec) => {
      testParms.push(rec.testParameter);
    });
    testParms = [...new Set(testParms)];
    var uDate = [];
    x.forEach((rec) => {
      //let dateFormat = new Date(rec.dataEntryDt).getDate() + '-' + mon[new Date(rec.dataEntryDt).getMonth()] + '-'+ new Date(rec.dataEntryDt).getFullYear();
      ///uDate.push(dateFormat);
      uDate.push(new Date(rec.dataEntryDt));
    });
    //console.log(uDate);
    //uDate = [...new Set(uDate)];
    uDate = [...new Map(uDate.map(item => [JSON.stringify(item), item])).values()];
    uDate.sort((a, b,) => a.valueOf() - b.valueOf());
    //console.log(uDate);
    var xAxis = [];
    xAxis.push("X");
    transformersName.forEach((tn) => {
      testParms.forEach((tp) => {
        let itemName = tn + ' - ' + tp;
        if (typeof tp != "undefined") {
          xAxis.push({ label: itemName, type: 'number' });
          xAxis.push({ role: "tooltip", type: "string", p: { html: true } });
        }
      });
    });

    //xAxis.push("SampleNumber");
    var yAxis = [];

    for (var v = 0; v < uDate.length; v++) {
      var yr = [];
      yr.push(uDate[v]);
      for (var k = 0; k < transformersName.length; k++) {
        for (var u = 0; u < testParms.length; u++) {
          yr.push(null);
          yr.push(null);
        }
      }
      yAxis.push(yr);
    }
    for (var i = 0; i < yAxis.length; i++) {
      let row = yAxis[i];
      for (var w = 0; w < x.length; w++) {
        var rec = x[w];
        // var mont = mon[new Date(rec.dataEntryDt).getMonth()];
        let mont = new Date(rec.dataEntryDt).getDate() + '-' + mon[new Date(rec.dataEntryDt).getMonth()] + '-' + new Date(rec.dataEntryDt).getFullYear();
        // var testp = rec.testParameter;
        let itemName = rec.name + ' - ' + rec.testParameter;
        let indexPara = xAxis.findIndex(obj => obj.label == itemName);
        //if (row[0] == mont) {
        if (row[0].getTime() === new Date(rec.dataEntryDt).getTime()) {
          yAxis[i][indexPara] = rec.testCountcss;
          let tooltip = "";
          tooltip += "Asset: " + itemName + "<br>";
          tooltip += "Value: " + rec.testCountcss + "<br>";
          tooltip += "Date: " + mont + "<br>";
          tooltip += "Sample No: " + rec.sampleControlNoCd;
          yAxis[i][indexPara + 1] = tooltip;
          //yAxis[i][3]=rec.sampleControlNoCd;
        }

      }
    }
    //console.log(xAxis);
    //console.log(yAxis);
    // if(xAxis.length > 1){
    // return [xAxis, ...yAxis];setSelectedVesselKey
    // } else {
    //   return [];
    // }

    return [xAxis, ...yAxis];
  }
  const clearChart = () =>{
    setChartData([])
    setChartResData([])
    setChartTestParameter([]);
}   

return (
    <Grid item xs={12} md={6} className="trendschart">
        <Dialog
            fullWidth={fullWidth}
            maxWidth="xl"
            fullScreen={true}
            open={open}
            onClose={handleClose}
        >
            <DialogActions>
                <Button onClick={handleClose}><CancelIcon /></Button>
            </DialogActions>

            <DialogContent>
                <SingleChart chartData={showchart} />
            </DialogContent>

        </Dialog>
        <Typography
                variant="h5"
                align="left"
                className={clsx(classes.heading, classes.theadingstyles)}
              >
                {"All Charts"}
                {chartData.length > 1 ? (
                  <button style={{ float: "right", padding: "0px" }} onClick={() => handleClickOpen("chart6")}>
                    <ZoomOutMapIcon />
                  </button>
                ) : ""}
                {chartData.length > 1 ? (
                    <button style={{ float: "right", padding: "0px" }} onClick={() => handleClickFileDownload()}>
                        <FileDownloadIcon />
                    </button>
                ) : ""}

              </Typography>
              <Paper
                className={classes.paper + " scrollBar"}
                style={{ height: "400px", overflow: "auto" }}
              >
                <Grid container spacing={3}>
                  <Grid item >
                    <Box component=""  >
                      <FormControl variant="outlined" className={classes.formControl + " cust-select-1"}
                        style={{ width: "100% !important" }}>
                        <Select
                          native
                          // value={formObj.typeofShip} 
                          // onChange={onChangeText}
                          value={selectBox['a']}
                          label="typeofShip"
                          inputProps={{
                            name: 'typeofShip',
                            id: 'outlined-typeofShip-native-simple',
                          }}
                          onChange={(event) => {
                            setSelectBox({ ...selectBox, 'a': event.target.value });
                            setSelectedTestParameterChat6(event);
                            
                          }}
                        >
                          <option aria-label="" value="" >Select</option>
                          <option aria-label="" value="Viscosity @ 40°C" >Viscosity @ 40°C</option>
                          <option aria-label="" value="Viscosity @ 100°C" >Viscosity @ 100°C</option>
                          <option aria-label="" value="Viscosity Index" >Viscosity Index</option>
                          <option aria-label="" value="Oxidation" >Oxidation</option>
                          <option value="Flash Point" >Flash Point</option>
                          <option aria-label="" value="Acid Number" >Acid Number</option>
                          <option aria-label="" value="Base Number" >Base Number</option>

                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                  <Grid item >
                    <Box component="">
                      <FormControl variant="outlined" className={classes.formControl + " cust-select-1"}
                        style={{ width: "100% !important" }}>
                        <Select
                          native
                          // value={formObj.typeofShip} 
                          // onChange={onChangeText}
                          value={selectBox['b']}
                          label="typeofShip"
                          inputProps={{
                            name: 'typeofShip',
                            id: 'outlined-typeofShip-native-simple',
                          }}
                          onChange={(event) => {
                            setSelectBox({ ...selectBox, 'b': event.target.value });

                            setSelectedTestParameterChat6(event);
                          }}
                        >
                          <option aria-label="" value="" >Select</option>
                          <option aria-label="" value="Vanadium" >Vanadium
                          </option>
                          <option aria-label="" value="Sodium" >Sodium
                          </option>
                          <option aria-label="" value="Silicon" >Silicon
                          </option>
                          <option aria-label="" value="Potassium" >Potassium
                          </option>
                          <option aria-label="" value="Soot Content" >Soot Content
                          </option>
                          <option aria-label="" value="Water By Karl Fischer" >Water By Karl Fischer
                          </option>

                          {/* {typeOfShipData.length ? (
                        typeOfShipData.map((row) => (
                          <option value={row}> {row}</option> */}

                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                  <Grid item >
                    <Box component="">
                      <FormControl variant="outlined" className={classes.formControl + " cust-select-1"}
                        style={{ width: "100% !important" }}>
                        <Select
                          native
                          // value={formObj.typeofShip} 
                          // onChange={onChangeText}
                          label="typeofShip"
                          value={selectBox['c']}
                          inputProps={{
                            name: 'typeofShip',
                            id: 'outlined-typeofShip-native-simple',
                          }}
                          onChange={(event) => {
                            setSelectBox({ ...selectBox, 'c': event.target.value });

                            setSelectedTestParameterChat6(event);
                          }}
                        >
                          <option aria-label="" value="" >Select</option>
                          <option aria-label="" value="Aluminium" >Aluminium</option>
                          <option aria-label="" value="Iron" >Iron</option>
                          <option aria-label="" value="Nickel" >Nickel</option>
                          <option aria-label="" value="Lead" >Lead</option>
                          <option aria-label="" value="Chromium" >Chromium</option>
                          <option aria-label="" value="Copper" >Copper</option>
                          <option aria-label="" value="Tin" >Tin</option>
                          <option aria-label="" value="Molybdenum" >Molybdenum</option>
                          <option aria-label="" value="PQ Index" >PQ Index</option>
                          <option aria-label="" value="Silver" >Silver</option>
                          <option aria-label="" value="Titanium" >Titanium</option>
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                  <Grid item >
                    <Box component="">
                      <FormControl variant="outlined" className={classes.formControl + " cust-select-1"}
                        style={{ width: "100% !important" }}>
                        <Select
                          native
                          // value={formObj.typeofShip} 
                          // onChange={onChangeText}
                          label="typeofShip"
                          value={selectBox['d']}
                          inputProps={{
                            name: 'typeofShip',
                            id: 'outlined-typeofShip-native-simple',
                          }}
                          onChange={(event) => {
                            setSelectBox({ ...selectBox, 'd': event.target.value });

                            setSelectedTestParameterChat6(event);
                          }}
                        >
                          <option aria-label="" value="" >Select</option>
                          <option aria-label="" value="Calcium" >Calcium</option>
                          <option aria-label="" value="Magnesium" >Magnesium</option>
                          <option aria-label="" value="Zinc" >Zinc</option>
                          <option aria-label="" value="Phosphorus" >Phosphorus</option>
                          <option aria-label="" value="Cadmium" >Cadmium</option>
                          <option aria-label="" value="Manganese" >Manganese</option>
                          <option aria-label="" value="Antimony" >Antimony</option>
                          <option aria-label="" value="Boron" >Boron</option>
                          <option aria-label="" value="Lithium" >Lithium</option>
                          <option aria-label="" value="Barium" >Barium</option>
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>


                  <Grid item >
                    <Box component=""  >
                      <FormControl variant="outlined" className={classes.formControl + " cust-select-1"}
                        style={{ width: "100% !important" }}>
                        <Select
                          native
                          // value={formObj.typeofShip} 
                          // onChange={onChangeText}
                          value={selectBox['e']}
                          label="typeofShip"
                          inputProps={{
                            name: 'typeofShip',
                            id: 'outlined-typeofShip-native-simple',
                          }}
                          onChange={(event) => {
                            setSelectBox({ ...selectBox, 'e': event.target.value });

                            setSelectedTestParameterChat6(event);
                          }}
                        >
                          <option aria-label="" value="" >Select</option>
                          <option aria-label="ISO" value=">4 micron(c)" > {">4 micron(c)"} </option>
                          <option aria-label="ISO" value=">6 micron(c)" > {">6 micron(c)"} </option>
                          <option aria-label="ISO" value=">14 micron(c)" >{">14 micron(c)"} </option>
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>

                </Grid>
                {
                  chartData.length > 1 ? (
                    <SingleChart chartData={chartData} />
                  ) : chartData.length == 1 ? (
                    <Box py={4} fontWeight="bold" >No Results found</Box>
                  ) : (
                    <React.Fragment>
                      {transformerListequip.length == 0 ? (
                        <Box py={4} fontWeight="bold" >Please select Ship key</Box>
                      ) : chartTestParameter.length == 0 || transformerListequip.length>0? (<Box py={4} fontWeight="bold" >Please select test parameters</Box>)
                        : (<Box py={4} fontWeight="bold" >No Records found</Box>)}
                    </React.Fragment>
                  )
                }
              </Paper>
              </Grid>
                          
);
}